/* @flow */
import React, { useRef, useState } from 'react';
import type { Node } from 'react';
import Slider from 'react-slick';
import { Portal } from 'react-portal';
import { Root, SlideStyle } from './styles';
import Lightbox from '../Lightbox';
import SliderImage from './SliderImage';

type TProps = {
	images: string[],
	apartId: string,
	isMobile: boolean,
	withoutScroll?: boolean,
};

const ImageSliderSmall = ({ images, apartId, isMobile, withoutScroll }: TProps) => {
	const [slide, setSlide] = useState(0);
	const [toggler, setToggler] = useState(false);
	const sliderRef = useRef(null);

	const getWithMoreValue = () => {
		if (isMobile) {
			return images.length > 3;
		}
		return images.length > 7;
	};
	const withMoreImages = getWithMoreValue();

	const getSlidesCount = () => {
		if (withMoreImages) {
			return isMobile ? 3 : 7;
		}
		return images?.length;
	};

	const getSliderImages = () => {
		if (withoutScroll) {
			return isMobile ? images.slice(0, 3) : images.slice(0, 7);
		}
		return images;
	};

	const slidesCount = getSlidesCount();
	const sliderImages = getSliderImages();

	const SLIDER_SETTINGS = {
		className: 'apartSmallSlider',
		dots: false,
		infinite: false,
		lazyLoad: true,
		arrows: false,
		speed: 500,
		slidesToShow: slidesCount,
		slidesToScroll: 1,
		accessibility: false,
	};

	const toggleLightbox = (idx): any => {
		setSlide(idx);
		setToggler(!toggler);
	};

	return (
		<Root>
			<SlideStyle />
			<Slider ref={sliderRef} {...SLIDER_SETTINGS}>
				{sliderImages.map((item, idx: number): Node => (
					<SliderImage
						link={item}
						idx={idx}
						key={idx.toString()}
						handleChange={() => toggleLightbox(idx)}
						withMoreImg={withMoreImages && idx === slidesCount - 1}
						countText={withMoreImages && images.length - slidesCount}
					/>
				))}
			</Slider>
			<Portal>
				<Lightbox toggler={toggler} sources={images} sourceIndex={slide} keyValue={apartId} />
			</Portal>
		</Root>
	);
};

ImageSliderSmall.defaultProps = {
	withoutScroll: false,
};

export default ImageSliderSmall;
